module.exports = __webpack_public_path__ + "media/images/quickbooks-4783dfa11f73a0e9c72592487437b8af.svg";